<template>
  <div class="w-full bg-ma-gray-0 px-4 py-3 flex-col justify-between">
    <div class="flex items-center justify-between relative">
      <div class="flex items-center w-full">
        <Avatar :src="member.avatar" :username="member.name || member.email" :size="30" style="min-width:30px" />
        <div class="flex flex-col ml-3 justify w-full">
          <div
            class="text-ma-black-1 font-bold text-sm leading-4 w-9/12 truncate"
          >
            {{ member.name }}
          </div>
          <div
            class="text-ma-gray-3 ext-base text-sm leading-4 w-10/12 truncate"
          >
            {{ member.email }}
          </div>
        </div>
      </div>
      <div v-if="member.available_actions && Object.keys(member.available_actions).length" class="member-edit-menu absolute right-0 top-0">
        <button
          class="flex text-ma-gray-3 px-2 py-1 uppercase text-xs font-bold hover:bg-ma-gray-1"
          :class="menuVisible ? 'bg-ma-gray-1' : ''"
          @click="$emit('openMenu')"
        >
          Edit
        </button>
        <!-- edit menu start -->
        <div
          v-if="menuVisible"
          class="absolute bg-white p-0 right-0 border border-ma-gray-11 w-40 shadow-md z-10"
        >
          <ul class="m-0 p-0 list-none">
            <template v-for="(item, label) in member.available_actions">
              <li
                :key="label"
                class="text-sm text-ma-black-0 px-4 py-1 cursor-pointer hover:bg-ma-gray-0"
                @click="$emit('clickItem', {item, label})"
              >
                {{ label }}
              </li>
            </template>
          </ul>
        </div>
        <!-- edit menu end -->
      </div>
    </div>
    <div class="flex justify-between items-center mt-3">
      <div class="text-ma-gray-3 text-sm" v-show="member.created_at">
        Added: {{ member.created_at | DATE("MMM Do, YYYY") }}
      </div>
      <div
        v-if="member.team_membership_status_status.name == 'Pending'"
        class="px-1 py-0 bg-ma-red-1 text-white text-xs text-2xs font-semibold h-full"
      >
        Pending
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from "vue-avatar";

export default {
  components: {
    Avatar,
  },
  props: {
    menuVisible: {
      type: Boolean,
      required: false,
      default: false,
    },
    member: {
      type: Object,
      required: true,
      default: {},
    },
  },
  data: () => ({
  }),
  methods: {
  },
};
</script>
<style scoped>
.text-2xs {
  font-size: 10px;
  height: 16px;
}
</style>
